import { actionCreator } from "src/store/dataService/actions/utils/actionCreator";
import { API } from "src/store/dataService/types";
import { MessageData } from "Types/api/Messages";

/**
 * Post Message request/success/failure
 */
export const postMessageRequest = actionCreator(
    "message/post/request",
    (message: string, uuid: string) => ({
        message,
        uuid,
    }),
    () => ({ route: API.Messages })
);

export const postMessageSuccess = actionCreator("message/post/success", (message: string, sent: string) => ({
    message,
    sent,
}));

export const postMessageFailure = actionCreator("message/post/failure", (message: string) => ({
    message,
}));

/**
 * Get Message request/success/failure
 */
export const getMessagesRequest = actionCreator(
    "messages/get/request",
    (uuid: string) => ({
        uuid,
    }),
    () => ({ route: API.Messages })
);

export const getMessagesSuccess = actionCreator("messages/get/success", (data: MessageData) => ({
    data,
}));

export const getMessagesFailure = actionCreator("messages/get/failure");
